"use client";

import Button from "../SecondaryButton";
import Modal from "./Modal";
import CheckIcon from "@/assets/check-mark.svg";

interface IProps {
  close: () => void;
  isOpen: boolean;
}

const UnstakeSuccessfulModal = ({ close, isOpen }: IProps) => {
  return (
    <Modal close={close} isOpen={isOpen} className="w-[90%] md:w-[660px]">
      <div className="flex flex-col gap-7 text-white text-center items-center">
        <div className="flex flex-col gap-4 items-center">
          <div className="flex flex-col gap-8 items-center">
            <CheckIcon className="w-20 h-20" />
            <span className="font-albert-sans text-2xl leading-7 uppercase">
              Unstake Request Submitted
            </span>
          </div>
          <p className="text-base leading-5">
            Your unstake request has been successfully submitted.
          </p>
          <p className="text-[18px] leading-5 font-bold">
            Your SPON will be available for withdrawal after 14 days.
          </p>
        </div>

        <Button className="w-max" variant="light" onClick={close}>
          <div className="px-20">CONFIRM</div>
        </Button>
      </div>
    </Modal>
  );
};

export default UnstakeSuccessfulModal;
